function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2292 6.72933C16.5442 6.72933 16.8462 6.85444 17.0689 7.07714C17.2916 7.29984 17.4167 7.60189 17.4167 7.91683V20.5835H30.0834C30.3703 20.5835 30.6476 20.6874 30.8638 20.876C31.0801 21.0647 31.2208 21.3252 31.2598 21.6095L31.2709 21.771C31.2709 29.6402 24.89 35.2293 17.0209 35.2293C13.2415 35.2293 9.617 33.728 6.9446 31.0556C4.27221 28.3832 2.77087 24.7587 2.77087 20.9793C2.77087 13.1102 8.36004 6.72933 16.2292 6.72933ZM20.9792 2.771C24.7585 2.771 28.3831 4.27233 31.0555 6.94473C33.7279 9.61712 35.2292 13.2417 35.2292 17.021C35.2292 17.3359 35.1041 17.638 34.8814 17.8607C34.6587 18.0834 34.3567 18.2085 34.0417 18.2085H20.9792C20.6643 18.2085 20.3622 18.0834 20.1395 17.8607C19.9168 17.638 19.7917 17.3359 19.7917 17.021V3.9585C19.7917 3.64355 19.9168 3.34151 20.1395 3.11881C20.3622 2.89611 20.6643 2.771 20.9792 2.771Z",
  fill: "black"
});

function SvgMiningdata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiningdata);
export default __webpack_public_path__ + "static/media/miningdata.1d0baf6d.svg";
export { ForwardRef as ReactComponent };